import { render } from "./HeroiconsSolidCurrencyRupee.vue?vue&type=template&id=d22ca512"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyRupee.vue"]])

export default __exports__